<template>
  <div class="floating-mobile-menu">
    <!-- Floating Roulette Icon -->
    <router-link
      v-if="$route.name === 'home'"
      :to="{ name: 'daily-roulette' }"
      class="floating-roulette-btn"
      title="Ruleta Diaria"
    >
      <div class="icon-container">
        <svg
          class="roulette-icon"
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          <!-- Gold Border -->
          <circle
            cx="50"
            cy="50"
            r="46"
            fill="#1e293b"
            stroke="#fbbf24"
            stroke-width="4"
          />
          <!-- Inner Rim -->
          <circle
            cx="50"
            cy="50"
            r="38"
            fill="none"
            stroke="#fbbf24"
            stroke-width="2"
            stroke-dasharray="4 6"
          />
          <!-- Segments -->
          <g transform="translate(50,50)">
            <path d="M0,0 L0,-38 A38,38 0 0,1 26.87,-26.87 Z" fill="#ef4444" />
            <path d="M0,0 L26.87,-26.87 A38,38 0 0,1 38,0 Z" fill="#10b981" />
            <path d="M0,0 L38,0 A38,38 0 0,1 26.87,26.87 Z" fill="#ef4444" />
            <path d="M0,0 L26.87,26.87 A38,38 0 0,1 0,38 Z" fill="#1e293b" />
            <path d="M0,0 L0,38 A38,38 0 0,1 -26.87,26.87 Z" fill="#ef4444" />
            <path d="M0,0 L-26.87,26.87 A38,38 0 0,1 -38,0 Z" fill="#1e293b" />
            <path d="M0,0 L-38,0 A38,38 0 0,1 -26.87,-26.87 Z" fill="#ef4444" />
            <path d="M0,0 L-26.87,-26.87 A38,38 0 0,1 0,-38 Z" fill="#1e293b" />
          </g>
          <!-- Center Hub -->
          <circle
            cx="50"
            cy="50"
            r="8"
            fill="#fbbf24"
            filter="drop-shadow(0 2px 4px rgba(0,0,0,0.5))"
          />
          <circle cx="50" cy="50" r="3" fill="#ffffff" />
        </svg>
      </div>
    </router-link>

    <!-- Bottom Navigation Bar -->
    <div class="bottom-nav">
      <router-link
        :to="{ name: 'home' }"
        class="nav-item"
        exact-active-class="active"
      >
        <a-icon type="home" />
        <span>Inicio</span>
      </router-link>

      <template v-if="authenticated">
        <router-link
          :to="{ name: 'buy' }"
          class="nav-item"
          exact-active-class="active"
        >
          <a-icon type="shopping-cart" />
          <span>Jugar</span>
        </router-link>

        <a-dropdown
          placement="topCenter"
          :trigger="['click']"
          overlayClassName="mobile-nav-dropdown"
        >
          <div class="nav-item">
            <a-icon type="swap" />
            <span>Transacción</span>
          </div>
          <a-menu slot="overlay">
            <a-menu-item key="deposit">
              <router-link
                :to="{
                  name: 'transaction-request',
                  query: { type: 'DEPOSIT' },
                }"
              >
                <a-icon type="bank" /> Depositar
              </router-link>
            </a-menu-item>
            <a-menu-item key="withdraw">
              <router-link
                :to="{
                  name: 'transaction-request',
                  query: { type: 'WITHDRAW' },
                }"
              >
                <a-icon type="wallet" /> Retirar
              </router-link>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>

      <template v-else>
        <router-link
          :to="{ name: 'results' }"
          class="nav-item"
          exact-active-class="active"
        >
          <a-icon type="ordered-list" />
          <span>Resultados</span>
        </router-link>

        <router-link
          :to="{ name: 'how-to-play' }"
          class="nav-item"
          exact-active-class="active"
        >
          <a-icon type="question-circle" />
          <span>¿Cómo jugar?</span>
        </router-link>
      </template>

      <div class="nav-item" @click="toggleMenu">
        <a-icon type="menu" />
        <span>Menú</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatingMobileMenu",
  props: {
    authenticated: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleMenu() {
      this.$emit("toggle-menu");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variable";

.floating-mobile-menu {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  pointer-events: none; /* Let clicks pass through the invisible wrapper */
}

.floating-mobile-menu > * {
  pointer-events: auto; /* Re-enable clicks for children */
}

.floating-roulette-btn {
  position: fixed;
  bottom: 146px;
  right: 20px;
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, var(--primary-color, #1890ff), #0050b3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(24, 144, 255, 0.4);
  color: #fff;
  transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: 1000;
  animation: pulse-glow 2s infinite;

  @media screen and (max-width: 991px) {
    bottom: 194px;
    right: 16px;
    width: 56px;
    height: 56px;
  }

  &:hover,
  &:active {
    transform: scale(1.1);
  }

  .icon-container {
    width: 48px;
    height: 48px;
    animation: roulette-spin 10s linear infinite;

    .roulette-icon {
      width: 100%;
      height: 100%;
    }
  }
}

@keyframes roulette-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse-glow {
  0% {
    box-shadow: 0 0 0 0 rgba(24, 144, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 12px rgba(24, 144, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(24, 144, 255, 0);
  }
}

.bottom-nav {
  display: none; /* Hidden on desktop */
  justify-content: space-around;
  align-items: center;
  background-color: var(--navbar-bg, rgba(255, 255, 255, 0.95));
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-top: 1px solid var(--border-color, rgba(0, 0, 0, 0.05));
  height: 70px;
  padding-bottom: env(safe-area-inset-bottom);
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);

  @media screen and (max-width: 991px) {
    display: flex; /* Visible on mobile */
  }

  .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--text, #8c8c8c);
    text-decoration: none;
    flex: 1;
    height: 100%;
    cursor: pointer;
    position: relative;
    transition: all 0.3s ease;

    i,
    .anticon {
      font-size: 22px;
      margin-bottom: 4px;
      transition: all 0.3s ease;
    }

    span {
      font-size: 11px;
      font-weight: 600;
      transition: all 0.3s ease;
    }

    &.active {
      color: var(--btn-text-secondary);

      i,
      .anticon {
        transform: translateY(-2px);
      }

      &::after {
        content: "";
        position: absolute;
        top: 4px;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: var(--btn-text-secondary);
      }
    }
  }
}
</style>

<style lang="scss">
.mobile-nav-dropdown {
  .ant-dropdown-menu {
    background-color: var(--navbar-bg, #fff);
    border: 1px solid var(--border-color, rgba(0, 0, 0, 0.05));
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);

    .ant-dropdown-menu-item {
      color: var(--text, rgba(0, 0, 0, 0.65));

      a {
        color: var(--text, rgba(0, 0, 0, 0.65));
      }

      &:hover {
        background-color: var(--hover-light, #f5f5f5);

        a {
          color: var(--btn-text-secondary, #1890ff);
        }
      }
    }
  }
}
</style>
